<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="view">
        <h2>Suivi du reporting trimestriel</h2>

        <b-col cols="10">
            <b-row>
                <b-col cols="4">
                    <b-form-group
                            id="input-group-trimestres"
                            label-for="input-trimestres">
                        <template v-slot:label>
                            <label-custom
                                    label="Trimestre de la saisie"
                                    tooltip="Trimestre de la saisie"
                                    :required="true">
                            </label-custom>
                        </template>
                        <b-form-select
                                id="input-trimestres"
                                v-model="trimestreId"
                                :options="trimestres"
                                @change="search"
                        >
                            <template v-slot:first>
                                <b-form-select-option :value="null">
                                    Sélectionner un trimestre
                                </b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="typo-warning" v-if="!trimestreId">
                            Ce champs est obligatoire
                        </div>
                    </b-form-group>
                </b-col>
                <b-col cols="1" offset="7">
                    <b-button type="button" variant="success" v-b-modal="'modal-choix-date-trimestriel'">Exporter</b-button>
                    <b-modal
                        id="modal-choix-date-trimestriel"
                        title="Choisir l'interval de trimestre"
                        ok-title="Confirmer"
                        cancel-title="Annuler"
                        hide-footer
                        @ok="preventOk">
                      <ReportingChoixDateTrimestriel
                          :trimestres="trimestres"
                      ></ReportingChoixDateTrimestriel>
                    </b-modal>
                </b-col>
            </b-row>

            <b-card header="Filtres de recherche" class="mb-3 mt-3">
                <b-row>
                    <b-col cols="2">
                        <b-form-group id="input-group-typeReporting"
                                      label="Onglet GPEC" label-for="input-typeReporting"
                        >
                            <b-form-select
                                    id="input-typeReporting"
                                    v-model="typeReporting">
                                <template v-slot:first>
                                    <b-form-select-option :value="null">
                                        Tout
                                    </b-form-select-option>
                                    <b-form-select-option :value="'prev'">
                                        GPEC - Besoins prév.
                                    </b-form-select-option>
                                    <b-form-select-option :value="'real'">
                                        GPEC - Bilan trimestriel
                                    </b-form-select-option>
                                </template>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group id="input-group-marches" label-for="input-marches">
                            <template v-slot:label>
                                <label-custom
                                        label="Marché"
                                        :tooltip=libelles.infoBulleNumMarche>
                                </label-custom>
                            </template>
                            <AutocompleteCustom
                                    id="input-marches"
                                    :items="marcheIdsItems"
                                    v-model="marcheId"
                                    @search="onMarcheSearch"
                                    :clear="ligneId.length"
                                    :placeholder=libelles.selectionnerMarche
                            >
                            </AutocompleteCustom>
                        </b-form-group>
                    </b-col>
                    <b-col cols="4">
                        <b-form-group id="input-group-lignes"
                                      label="Ligne" label-for="input-lignes"
                        >
                            <MultiselectCustom
                                    :options="lignes"
                                    v-model="ligneId"
                                    :defaultLabel="'Sélectionner une ligne'"
                                    :required="true"
                                    @change="marcheId = null; search();"
                                    id="input-lignes"
                            >
                            </MultiselectCustom>
                        </b-form-group>
                    </b-col>
                    <b-col cols="2">
                        <b-form-group id="input-group-statut"
                                      label="Statut" label-for="input-statut">
                            <b-form-select
                                    id="input-statut"
                                    v-model="statut"
                                    @change="search">
                                <b-form-select-option :value="null">
                                    Tous
                                </b-form-select-option>
                                <b-form-select-option value="OK">
                                    Reporting fait
                                </b-form-select-option>
                                <b-form-select-option
                                        value="KO">
                                    Reporting non fait
                                </b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-card>
            <div v-if="reportingResult">
                <b-row class="mb-3">
                    <b-col cols="2">
                        <b-button size="sm" variant="success">Fait dans les temps</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" :class="'BROUILLON'">Brouillon à valider</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" variant="warning">Fait en retard ou modifié</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" variant="danger">Non fait</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" variant="secondary">Non demandé</b-button>
                    </b-col>
                </b-row>
                <b-row class="mb-3">
                    <b-col cols="2">
                        <b-button size="sm" variant="primary">Dispense utilisateur</b-button>
                    </b-col>
                    <b-col cols="2">
                        <b-button size="sm" class="DISPENSE_FORMULAIRE">Fait malgré dispense</b-button>
                    </b-col>
                </b-row>
                <b-table striped hover
                         :no-local-sorting="true"
                         :items="reportingTable" :fields="fields">
                    <template v-slot:cell(num)="row">
                        <div>
                            {{row.index + 1}}
                        </div>
                    </template>
                    <template v-slot:cell(statutGpecPrevisionnel)>
                    </template>
                    <template v-slot:cell(statutGpecRealise)>
                    </template>
                </b-table>
            </div>
        </b-col>
    </div>
</template>

<script>
  import ReportingStore from "../../stores/ReportingStore";
  import ReportingSearchDto from "../../dtos/ReportingSearchDto";
  import LabelCustom from "../../components/LabelCustom";
  import AutocompleteCustom from "../../components/AutocompleteCustom";
  import MultiselectCustom from "../../components/MultiselectCustom";
  import AlertStore from "../../stores/AlertStore";
  import MarcheStore from "../../stores/MarcheStore";
  import LigneStore from "../../stores/LigneStore";
  import SessionStore from '@/stores/SessionStore'
  import TrimestreStore from "../../stores/TrimestreStore";
  import _ from 'lodash';
  import {libelles} from "../../constants/libelles";
  import ReportingChoixDateTrimestriel from "./ReportingChoixDateTrimestriel";

  export default {
    components: {
      LabelCustom,
      AutocompleteCustom,
      MultiselectCustom,
      ReportingChoixDateTrimestriel
    },
    data() {
      return {
        sessionStoreState: SessionStore.state,
        marcheId: null,
        ligneId: [],
        marches: [],
        lignes: [],
        statut: null,
        typeReporting: null,
        reportingResult: null,
        trimestreId: null,
        trimestres: [],
        libelles: libelles,
        marcheIdsItems: [],
        marchesAdmin: [],
      }
    },
    watch: {
      marcheId() {
        if (this.marcheId) {
          this.ligneId = [];
        }
        this.search();
      }
    },
    computed: {
      fields() {
        const fields = [
          {label: '', key: 'num'},
          {label: 'Référence marché', key: 'referenceMarche'},
          {label: 'Libellé court marché', key: 'libelleCourtMarche'},
          {label: 'GPEC – Besoins prév.', key: 'statutGpecPrevisionnel', tdClass: 'setBackground'},
          {label: 'GPEC – Bilan trimestriel', key: 'statutGpecRealise', tdClass: 'setBackground'}
        ];
        if (this.typeReporting === 'prev') {
          fields.splice(3, 1);
        }
        if (this.typeReporting === 'real') {
          fields.splice(2, 1);
        }
        return fields;
      },
      reportingTable: function () {
        return this.reportingResult.map(reporting => {
          return {
            referenceMarche: reporting.marche.replace(')', '').split('(')[0],
            libelleCourtMarche: reporting.marche.replace(')', '').split('(')[1],
            statutGpecPrevisionnel: reporting.marcheCloture ? 'MARCHE_CLOTURE' : reporting.statutGpecPrevisionnel,
            statutGpecRealise: reporting.marcheCloture ? 'MARCHE_CLOTURE' : reporting.statutGpecRealise,
          }
        });
      }
    },
    mounted() {
      MarcheStore.getAll().then(marches => {
        this.marches = marches;
        this.marchesAdmin = marches.map(marche => {
          return {text: `${marche.reference} (${marche.libelleCourt})`, value: marche.id};
        });
        this.marcheIdsItems = this.marchesAdmin;
      });
      LigneStore.getAll().then(
          response => this.lignes = response.map(value => {
            return {text: value.libelleLong, value: value.id};
          })
      );
      TrimestreStore.getAll().then((trimestres) => {
        this.trimestres = trimestres.map(function (trimestre) {
          return {text: trimestre.libelle, value: trimestre.id};
        });
      });
    },
    methods: {
      onFilterChange: _.debounce(function () {
        this.search();
      }, 1000),
      search() {
        if (this.trimestreId) {
          const reporting = this.createReportingRecherche();
          ReportingStore.search(reporting, false).then(
              result => {
                this.reportingResult = result.data;
              },
              error => AlertStore.pushError(error.response.data.message)
          )
        }
      },
      createReportingRecherche() {
        const reporting = new ReportingSearchDto();
        reporting.marcheId = this.marcheId;
        reporting.ligneId = this.ligneId;
        reporting.statut = this.statut;
        reporting.trimestreId = this.trimestreId;
        return reporting;
      },
      setBackground(item) {
        return item;
      },
      onMarcheSearch(marche, isId) {
        this.marcheIdsItems = MarcheStore.onMarcheSearch(marche, isId, this.marchesAdmin)
      },
      preventOk(evt) {
        evt.preventDefault();
      }
    }
  }
</script>
